import * as React from "react";

import { SetTooltipProps } from "@1js/acui-common";
import { ExperimentChecker } from "@1js/acui-experiments";

export interface AppContextType extends ExperimentChecker {
  setTooltipElement?: (tooltipProps: SetTooltipProps) => void;
  updateTooltipsHidden?: (hideAllTooltips: boolean) => void;
  appWindow?: Window;
}

export const AppContext: React.Context<AppContextType> = React.createContext(
  {}
);
AppContext.displayName = "AppContext";
